import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-telefone-sichtbar-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerTelefoneSichtbarAdminEffects {

    BenutzerTelefoneSichtbarAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN),
        mergeMap((x: ac.PostBenutzerTelefoneSichtbarAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerTelefoneSichtbarAdmin(x.benutzerTelefoneSichtbarkeitRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerTelefoneSichtbarAdminErfolgreichAction(result, x.benutzerTelefoneSichtbarkeitRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerTelefoneSichtbarAdminFehlerAction(error, x.benutzerTelefoneSichtbarkeitRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
